import { createEntityAdapter, EntityId, EntityState } from "@reduxjs/toolkit";
import { DossierExport } from "types/DossierExport";

export const dossierExportsAdapter = createEntityAdapter<DossierExport>();

export interface CaseExportsState {
    dossierId?: EntityId;
    dossierExports: EntityState<DossierExport, EntityId>;

    totalDossierExports?: number;
    isLoadingDossierExports: boolean;
    errorLoadingDossierExports?: string;
}

export const initialState: CaseExportsState = {
    dossierId: undefined,
    dossierExports: dossierExportsAdapter.getInitialState(),

    totalDossierExports: undefined,
    isLoadingDossierExports: false,
    errorLoadingDossierExports: undefined,
};
